// extracted by mini-css-extract-plugin
export var printerCard = "_i4-1";
export var printerCardConfigured = "_i4-2";
export var printerCardError = "_i4-3";
export var printerCardsContainer = "_i4-0";
export var printerIcon = "_i4-8";
export var printerIconConfigured = "_i4-5";
export var printerIconContainer = "_i4-4";
export var printerIconError = "_i4-6";
export var printerIconUnconfigured = "_i4-7";
export var workstationsTableCard = "_i4-9";